import GroupDeleteModal from "./GroupDeleteModal";
export default GroupDeleteModal;
